<iframe *ngIf="isEmbeddedDashboardLinkReady" [src]="embeddedDashboardLink" class="dashboard-iframe"></iframe>
